import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Label } from "@/components/ui/label";
import { Database, Copy } from "lucide-react";
import { toast } from "sonner";
import type { DatabaseConfig } from '@/types/database';
import { getDatabaseTypeLabel, getDatabaseTypeBadgeColor, copyConfigToClipboard } from '@/utils/databaseHelpers';

interface CurrentDatabaseConfigProps {
  currentConfig: DatabaseConfig | null;
}

export function CurrentDatabaseConfig({ currentConfig }: CurrentDatabaseConfigProps) {
  const handleCopyConfig = () => {
    if (currentConfig) {
      copyConfigToClipboard(currentConfig);
      toast.success("تم نسخ الإعدادات");
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <span className="flex items-center gap-2">
            <Database className="h-5 w-5" />
            الإعداد الحالي
          </span>
          {currentConfig && (
            <div className="flex gap-2">
              <Badge className={getDatabaseTypeBadgeColor(currentConfig.type)}>
                {getDatabaseTypeLabel(currentConfig.type)}
              </Badge>
              <Badge variant="default" className="bg-green-500">
                نشط
              </Badge>
            </div>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {currentConfig ? (
          <div className="space-y-3">
            <div>
              <Label className="text-sm font-medium">اسم الإعداد</Label>
              <p className="text-sm text-muted-foreground">{currentConfig.name}</p>
            </div>
            
            {currentConfig.type === 'supabase' ? (
              <>
                <div>
                  <Label className="text-sm font-medium">رابط قاعدة البيانات</Label>
                  <p className="text-sm text-muted-foreground font-mono break-all">{currentConfig.config.url}</p>
                </div>
                <div>
                  <Label className="text-sm font-medium">مفتاح API</Label>
                  <p className="text-sm text-muted-foreground font-mono break-all">
                    {currentConfig.config.anonKey?.substring(0, 20)}...
                  </p>
                </div>
              </>
            ) : (
              <>
                <div>
                  <Label className="text-sm font-medium">المضيف</Label>
                  <p className="text-sm text-muted-foreground">{currentConfig.config.host}</p>
                </div>
                <div>
                  <Label className="text-sm font-medium">المنفذ</Label>
                  <p className="text-sm text-muted-foreground">{currentConfig.config.port}</p>
                </div>
                <div>
                  <Label className="text-sm font-medium">قاعدة البيانات</Label>
                  <p className="text-sm text-muted-foreground">{currentConfig.config.database}</p>
                </div>
                <div>
                  <Label className="text-sm font-medium">اسم المستخدم</Label>
                  <p className="text-sm text-muted-foreground">{currentConfig.config.username}</p>
                </div>
              </>
            )}
            
            <Button
              variant="outline"
              size="sm"
              onClick={handleCopyConfig}
              className="flex items-center gap-2"
            >
              <Copy className="h-4 w-4" />
              نسخ الإعدادات
            </Button>
          </div>
        ) : (
          <p className="text-muted-foreground">لا يوجد إعداد نشط</p>
        )}
      </CardContent>
    </Card>
  );
}